import React from "react";
import distanceInWordsStrict from "date-fns/distance_in_words_strict";
import differenceInDays from "date-fns/difference_in_days";
import format from "date-fns/format";

export default (content, verbose = false) => {
  if (content.published_date) {
    const month = verbose ? "MMMM" : "MMM";
    // Show relative time if article was published less than a day ago
    if (differenceInDays(content.published_date, new Date()) > -1) {
      // Less than an hour old: "[x] mins ago"
      // Less than a day but more than an hour: "[x] hrs ago"
      let distance = distanceInWordsStrict(new Date(), content.published_date, {
        addSuffix: true,
      });
      return distance.replace("minute", "min");
    }
    // Otherwise show the absolute date
    else {
      return format(content.published_date, `${month} D, YYYY`);
    }
  } else {
    if (content.status && content.status !== "published") {
      return <i>unpublished</i>;
    } else {
      // Published items with a published date of null are a big no-no.
      // This maybe should even throw an error.
      return null;
    }
  }
};
